import {
    Grid,
    Typography,
    withStyles,
    Theme,
    Box,
    FormControlLabel,
    Button,
    TextField
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
// import fileDownload from 'js-file-download'
// import BulbOutlineIcon from 'mdi-react/BulbOutlineIcon'
import CancelIcon from 'mdi-react/CancelCircleOutlineIcon'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
// import DownloadIcon from 'mdi-react/DownloadIcon'

import { useEffect, useState, useCallback, useLayoutEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { Dispatch } from 'redux'
import { reduxForm, change, Field, formValueSelector } from 'redux-form'
import { stepAfterShowingForward } from '../../actions/apartments'
import ConfirmationDialogRaw from '../../components/ConfirmationDialogRaw/ConfirmationDialog'
import {
    ReduxCheckbox,
    ReduxFormField
} from '../../components/FormInput/ReduxWrappers'
import LoadingContainer from '../../components/LoadingContainer/LoadingContainer'
import OutlineLockPersonIcon from '../../images/ic_outline-lock-person.svg'
import suggestIcon from '../../images/suggest.svg'
import { charsSpace, onlyNums } from '../../libs/normalize/information'
import Api from '../../services/applications'
import i18n from '../../translations/i18n'
import { MuiClasses } from '../../types'
import { ApartmentInformation, DropDownItem } from '../../types/apartments'
import { AutocompleteOption } from '../../types/autocomplete'
import { ReduxForm } from '../../types/forms'
import { WaterFeeBasis } from '../../types/propValues/apartments'
import { StateInterface } from '../../types/states'
import {
    isInvalidCharacters,
    isPostalCode,
    noSpacesPhoneNum,
    noSpaceValue,
    required,
    requiredLocation,
    validateEmail,
    validatePhoneNumber
} from '../../utils/validation/forms'
import { MyInput } from '../NewApplication/Fields'
import { BackButton } from '../InstantRentApplication/BackButton'
import AcceptOrDecline from './InnerPages/AcceptOrDecline'
import StartAuthTrigger from '../InstantRentApplication/StartAuthTrigger'
import { ApplicationStatus } from '../../types/applications'
import ApplicationsApi from '../../services/applications'
import phoneAndHouse from '../../images/afterShowing/phoneAndHouse.svg'

const styles = ({ breakpoints, typography }: Theme) => ({
    formContainer: {
        // padding: '35px 0 15px 0',
        // maxWidth: '550px',
        maxWidth: '1131px',
        margin: 'auto',
        marginTop: '3.5rem !important',
        '@media (max-width: 960px)': {
            marginTop: '1rem !important',
        }
    },
    modalMobile: {
        [breakpoints.down('sm')]: {
            margin: '20px'
        }
    },
    paymentOption: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        flexWrap: 'wrap',
        marginTop: '30px'
    } as const,
    paymentCard: {
        // width: '23% '
    },
    buttons: {
        margin: '2rem 0 2rem 0',
        width: '100%',
        [breakpoints.down('sm')]: {
            bottom: 0,
            margin: 0,
            marginTop: '2rem',
            marginBottom: '1.5rem',
            backgroundColor: '#fff',
            padding: '4px'
        }
    },
    button: {
        // width: '48%',
        [breakpoints.down('sm')]: {
            borderRadius: 0
        }
    },
    buttonGridContainer: {
        width: '47.5%'
    },
    cancelTextButton: {
        color: '#D43838',
        fontSize: '1.375rem',
        height: '65px',
        textTransform: 'none' as const,
        background: 'none',
        boxShadow: 'none',
        fontWeight: 'bold' as const,
        backgroundColor: '#fff',
        '&:hover': {
            background: 'none',
            boxShadow: 'none'
        },
        [breakpoints.down('sm')]: {
            // marginBottom: '100px'
        }
    },
    responsiveWidth: {
        [breakpoints.down('sm')]: {
            padding: '0 1rem'
        }
    },
    leaseContainer: {
        marginTop: '4rem',
        marginBottom: '4.5rem',
        [breakpoints.down('sm')]: {
            marginTop: '3.2rem',
            marginBottom: '2.25rem'
        }
    },
    moversSection: {
        marginTop: '3.6rem',
        [breakpoints.down('sm')]: {
            marginTop: '2rem'
        }
    },
    moversContainer: {
        padding: '40px 30px 47px 41px',
        borderRadius: '20px',
        [breakpoints.down('sm')]: {
            padding: '32px 30px 43px 30px'
        }
    },
    leaseDurationTitle: {
        marginBottom: '2rem',
        [breakpoints.down('sm')]: {
            marginBottom: '1.625rem'
        }
    },
    moversTitle: {
        marginBottom: '1.6rem',
        [breakpoints.down('sm')]: {
            marginBottom: '1.875rem'
        }
    },
    moversField: {
        margin: '1.4rem auto 1.2rem auto',
        '& .react-select__control': {
            padding: '2px 8px',
            borderRadius: '8px'
        },
        '& .react-select__placeholder': {
            fontSize: '16px'
        },
        [breakpoints.down('sm')]: {
            margin: '1.8rem auto 1.625rem auto'
        }
    },
    inlineDatePicker: {
        // border: '2px solid red',
        borderRadius: '8px'
    },
    labelText: {
        fontSize: typography.pxToRem(18)
    },
    formLabel: {
        fontSize: typography.pxToRem(20),
        [breakpoints.down('sm')]: {
            fontSize: typography.pxToRem(16),
            marginBottom: '8px'
        }
    },
    customInputLabel: {
        // Add custom styles for label
        paddingLeft: '5px', // Example padding
    },
    customInput: {
        // Add custom styles for input
        '& input': {
            paddingLeft: '5px', // Padding inside the input
        },
    },
    calendarInputContainer: {
        padding: '25px 32px 29px 32px',
        [breakpoints.down('sm')]: {
            // padding: '36px 16px 37px 42px'
            padding: '36px 25px 37px 25px;',
            marginBottom: '20px'
        }
    },
    containerStyle: {
        marginLeft: '30px',
        [breakpoints.down('sm')]: {
            marginLeft: '0px'
        }
    },
    sartDateRow: {
        height: '178px',
        alignItems: 'center',
        [breakpoints.down('sm')]: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfo: {
        '> div': {
            display: 'flex'
        },
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfoDetails: {
        display: 'flex',
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    dialogContanier: {
        paddingTop: '3.875rem',
        paddingBottom: '3.875rem'
    },
    authPrompt: {
        padding: '54px 0',
        marginTop: '1.5rem',
        [breakpoints.down('sm')]: {
            padding: '84px 0'
        }
    },
    applicantInfo: {
        // padding: '54px 0',
        marginTop: '51px',
        [breakpoints.down('sm')]: {
            padding: '2rem 0',
            marginBottom: '7rem'
        }
    },
    authDesc: {
        marginTop: '2rem',
        marginBottom: '1.5rem'
    },
    requiredField: {
        '&:after': {
            content: '"*"',
            color: 'red'
        }
    },
    labelChecker: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '10px 0',
        [breakpoints.down('sm')]: {
            padding: '15px',
            paddingLeft: '2em',
            paddingRight: '1em',
            marginRight: '0'
        }
    },
    heading: {
        [breakpoints.down('sm')]: {
            fontSize: '1.1rem'
        }
    },
    mBottom: {
        marginBottom: '10px'
    },
    suggestIcon: {
        objectFit: 'contain',
        width: '30px',
        [breakpoints.down('sm')]: {
            marginBottom: '10px'
        }
    } as const,
    paragraphStyle: {
        fontSize: '1.1rem',
        '& span': {
            color: '#4F9B44'
        },
        [breakpoints.down('sm')]: {
            marginRight: '10px',
            marginLeft: '20px'
        }
    },
    modalSecondaryButton: {
        marginTop: '20px'
    },
    acceptedDeclinedFormContainer: {
        height: '100vh',
        alignItems: 'center',
        [breakpoints.up('md')]: {
            height: 'auto',
        },
    },
    acceptedDeclinedText: {
        fontSize: '2rem',
        lineHeight: '3.25rem',
        marginBottom: '1.25rem',
        fontWeight: typography.fontWeightBold,
        marginLeft: '3.5rem',
        [breakpoints.between('md', 1200)]: {
            marginLeft: '6.3rem',
        },
        [breakpoints.down('md')]: {
            marginLeft: '1.79rem',
            marginRight: '1rem'  // Adjust this to what you find suitable for smaller screens
        },
    },
    listItems: {
        marginLeft: '2.7rem',
        fontWeight: typography.fontWeightLight,
        '& li': {
            marginBottom: '1.25rem',
            listStyle: 'none',
            position: 'relative',
            '&::before': {
                content: "'•'",
                color: '#4f9b44',
                position: 'absolute',
                left: '-28px',
            },
        },
        [breakpoints.between('md', 1200)]: {
            marginLeft: '5.5rem',
        },
        [breakpoints.down('md')]: {
            marginLeft: '1rem',
            marginRight: '1rem'  // Adjust this to what you find suitable for smaller screens
        },
    },
    imageContainer: {
        width: '100%',  // this will ensure the image doesn't extend beyond its parent container
        '& img': {
            maxWidth: '100%',  // this will ensure the image doesn't extend beyond the imageContainer
        },
    },
    headerStyle: {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'CircularRegular',
        fontSize: '2rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '3.25rem', // 162.5%
        marginBottom: '2rem',
    },
})

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 560,
        backgroundColor: theme.palette.background.paper
    },
    paper: {
        width: '100%',
        borderRadius: 35,
        margin: '0px !important'
    }
}))

interface InstantRentFormProps
    extends WithTranslation,
    ReduxForm,
    ApartmentInformation {
    autocompleteLocation: undefined | AutocompleteOption | string
    saveInstantRentForm: (arg: any) => any
    isDisabled: boolean
    classes: MuiClasses
    t: i18n.TFunction
    changeFormValue: (field: string, value: string) => void
    currentStep: any
    doStepBack: () => void
    isMobile: any
    waterFeeBasis: WaterFeeBasis | undefined
    beforeLogin?: boolean
    doNextStep: any
    readyForMoveDate: any
    movingWithAmount: number | DropDownItem
    acceptedTc: boolean
    contactEmail: string
    phoneNumber: string
    postalCode: string
    postalArea: string
}
const InstantRentForm = ({
    classes,
    t,
    handleSubmit,
    submitting,
    saveInstantRentForm,
    doStepBack,
    movingWithAmount,
    readyForMoveDate,
    acceptedTc,
    currentStep,
    isMobile,
    beforeLogin,
    isDisabled,
    doNextStep,
    contactEmail,
    phoneNumber,
    autocompleteLocation,
    postalCode,
    postalArea
}: InstantRentFormProps) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const routeMatch = useRouteMatch()
    const applicationCode = (routeMatch.params as any).applicationCode
    const location = useLocation()

    //validation
    // useEffect(() => {
    //     if (
    //         [4, 5, 6, 7, 8].includes(currentStep) &&
    //         !localStorage.getItem('application')
    //     ) {
    //         history.push(`/instant-rent/${applicationCode}/steps/1`)
    //     }
    // })

    useEffect(() => {
        if (localStorage.getItem('authInfo') !== undefined) {
            const { language, movingWithAmount, readyForMoveDate } = JSON.parse(
                localStorage.getItem('authInfo') || '[]'
            )
            dispatch(change('InstantRentForm', 'movingWithAmount', movingWithAmount))
            dispatch(change('InstantRentForm', 'readyForMoveDate', readyForMoveDate))
            dispatch(change('InstantRentForm', 'applicationCode', applicationCode))
            dispatch(change('InstantRentForm', 'language', language))
        }
    }, [])

    const [isEmpty, setIsEmpty] = useState(false)
    // const [checkStepOnw, setCheckStepOnw] = useState(true)
    //const [appResponse, setAppResponse] = useState(null) as any
    const [applicantCreditStatus, setApplicantCreditStatus] = useState(false)
    const [authenticationError, setAuthenticationError] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [newRentDialog, setNewRentDialog] = useState(null) as any
    //const [rentedDialog, setRentedDialog] = useState(null) as any
    const [open, setOpen] = useState(true)
    //const [acceptDraftCheck, setAcceptDraftCheck] = useState(false)
    //const [isTour, setTour] = useState(false)
    //onst [isPaymentStatus, setPaymentStatus] = useState(null) as any
    //const [failedPaymentModal, setFailedPaymentModal] = useState(true)
    //const [isLoadingPDF, setIsLoadingPDF] = useState(false)
    const [application, setApplication] = useState(null)
    const [duplicateAuthentication, setDuplicateAuthentication] = useState(false)
    // isApartment,
    // const [setApartment] = useState(null) as any
    const [email, setEmail] = useState('');
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailValidationError, setEmailValidationError] = useState(false);

    const dialogClasses = useStyles()
    const url = new URL(window.location.href)
    const [isSecondary, setIsSecondary] = useState(false);

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    useEffect(() => {
        const isSecondaryFromQuery = query.get('secondary') === 'true';

        const storedItem = localStorage.getItem('secondary');
        let secondaryValue = false;

        if (storedItem) {
            const { value, expiry } = JSON.parse(storedItem);
            if (new Date().getTime() < expiry) {
                secondaryValue = value;
            } else {
                localStorage.removeItem('secondary');
            }
        }

        if (isSecondaryFromQuery) {
            const expiryTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
            const item = { value: true, expiry: expiryTime };
            localStorage.setItem('secondary', JSON.stringify(item));
            secondaryValue = true;
        }

        setIsSecondary(secondaryValue)
    }, []);

    const navigateTo = useCallback(
        (newStep) => {
            history.push(`/aftershowing/${applicationCode}/steps/${newStep}`)
        },
        [history, routeMatch]
    )

    const setStorageItem = (applicaiton: any, name = 'application') => {
        localStorage.setItem(name, JSON.stringify(applicaiton))
    }

    const getStorageItem = (name = 'application'): any => {
        return JSON.parse(localStorage.getItem(name) || '{}')
    }

    const validateApplicantCreditInfoSaved = async () => {
        const status = url.searchParams.get('status')
        //console.log(status);

        if (!status) {
            return
        }

        if (status == 'duplicate') {
            setDuplicateAuthentication(true)
            setAuthenticationError(true)
            return
        }

        if (status !== 'success') {
            setDuplicateAuthentication(false)
            setAuthenticationError(true)
            return
        }

        setLoading(true)

        await Api.getApplicationByCode(`${applicationCode}`)
            .then((response: any) => {
                //setAppResponse(response)
                setStorageItem(response)
                if (response.applicants && response.applicants.every(applicant => applicant.creditInfo)) {
                    navigateTo(3)
                    //tämä local storagen avulla?
                    //  setApplicantCreditStatus(false)
                    setLoading(false)
                } else {
                    setAuthenticationError(true)
                    setLoading(false)
                    return
                    //TÄHÄN JOTAIN MESSAGEA?
                    //PITÄÄ TEHDÄ UUSI HAKEMUS?
                    //  setApplicantCreditStatus(true)
                    //CLEAR APPLICANTS NAPPI?
                }
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    //restart application
    const handleRestartApplication = () => {
        setOpen(false)
        localStorage.clear()
        navigateTo(1)
    }

    // Add new Tenant
    const addNewTenant = () => {
        //setOpen(false)
        //navigateTo(2)
        setEmailSent(false)
        setShowEmailForm(true);
    }

    const handleSendEmail = async () => {
        try {
            setEmailSent(false);
            setEmailError(false);
            setEmailValidationError(false);

            if (!email || validateEmail(email)) {
                setEmailValidationError(true);
                return
            }

            const response = await Api.sendAfterShowingMail(email, applicationCode);

            if (response.status !== 200) {
                setEmailError(true)
                return
            }

            setEmailSent(true)
            setShowEmailForm(false)
            setEmail('')
        } catch (error) {
            //console.error('Error sending email:', error);
            setEmailError(true);
        }
    };
    const handleFormEvent = () => {
        const isContactEmailValid = !required(contactEmail) && !noSpaceValue(contactEmail) && !validateEmail(contactEmail);
        const isPhoneNumberValid = !required(phoneNumber) && !noSpacesPhoneNum(phoneNumber) && !validatePhoneNumber(phoneNumber);
        const isPostalAreaValid = !requiredLocation(postalArea) && !isInvalidCharacters(postalArea);
        const isPostalCodeValid = !required(postalCode) && !isPostalCode(postalCode) && !isInvalidCharacters(postalCode);
        const isAutocompleteLocationValid = !requiredLocation(autocompleteLocation) && !isInvalidCharacters(autocompleteLocation);

        if (
            contactEmail &&
            isContactEmailValid &&
            phoneNumber &&
            isPhoneNumberValid &&
            autocompleteLocation &&
            isAutocompleteLocationValid &&
            postalCode &&
            isPostalCodeValid &&
            postalArea &&
            isPostalAreaValid
        ) {
            setIsEmpty(false)
            setLoading(true)

            const { code = '', ...application } = getStorageItem()


            //applicants status=created before updateInfo (step4)
            const applicant = application?.applicants?.find(
                (x: { status: string }) => x.status === 'created'
            )


            const readyForMoveDateFromStorage = localStorage.getItem('readyForMoveDate');
            const readyForMoveDate = readyForMoveDateFromStorage ? new Date(readyForMoveDateFromStorage) : null;

            Api.updateAfterShowingApplication({
                applicationCode: applicationCode,
                applicantCode: applicant?.code,
                email: contactEmail,
                phone: phoneNumber,
                address: autocompleteLocation,
                postalCode: postalCode,
                postalArea: postalArea,
                readyForMoveDate: readyForMoveDate,
            })
                .then((response) => {
                    setStorageItem(response)
                    if (isSecondary) {
                        goFromStep3To4()
                    } else {
                        setNewRentDialog(response)
                    }
                    setLoading(false)
                    //navigateTo(5)
                })
                .catch((error) => {
                    setLoading(false)
                })
        } else {
            setIsEmpty(true)
            setLoading(false)
        }
    }

    const startCreditScoreAuth = () => {
        setIsEmpty(false)
        setLoading(true)

        //localStorage.setItem('readyForMoveDate', readyForMoveDate);

        Api.initiateAuthorizationForCreditScore({
            applicationCode: applicationCode,
        })
            .then((response) => {
                window.location.href = response.authenticationUrl;
                // setStorageItem(response)
                // setNewRentDialog(response)
                setLoading(false)
                //navigateTo(5)
            })
            .catch((error) => {
                setLoading(false)
            })
    }


    const goFromStep3To4 = () => {
        const applicationData = JSON.parse(localStorage.getItem(application.applicationId) || '{}');
        applicationData.processCompleted = true;
        localStorage.setItem(application.applicationId, JSON.stringify(applicationData));
        localStorage.removeItem('secondary');
        navigateTo(4);
    };

    const resetNotInterested = async () => {
        setLoading(true)
        await ApplicationsApi.updateApplicationStatusByCode(applicationCode, {
            status: ApplicationStatus.created
        });
        setLoading(false)
        navigateTo(1)
    }

    useEffect(() => {
        const readyForMoveDateFromStorage = localStorage.getItem('readyForMoveDate')
        if (currentStep === 1) {
            localStorage.removeItem('authinfo')
        }
        if ((currentStep === 2 || currentStep === 3) && !readyForMoveDateFromStorage && !readyForMoveDate) {
            // Redirect to step 1 using React Router history
            history.push(`/aftershowing/${applicationCode}/steps/1`)
        } else if (currentStep === 2) {
            validateApplicantCreditInfoSaved();
        }
    }, [currentStep])

    useEffect(() => {
        const fetchApplication = async () => {
            if (!application) {
                setLoading(true)
                try {
                    const applicationResponse = await Api.getApplicationByCode(`${applicationCode}`);
                    setApplication(applicationResponse)

                    const applicationData = JSON.parse(localStorage.getItem(applicationResponse.applicationId) || '{}');
                    if (applicationData && applicationData.processCompleted) {
                        navigateTo(4);
                        return;
                    }

                    if (applicationResponse.status == ApplicationStatus.notInterested) {
                        navigateTo(0)
                    }
                    if (applicationResponse.status == ApplicationStatus.wantsContract) {
                        //navigateTo(4)
                    }
                    if (applicationResponse.status == ApplicationStatus.created && (currentStep === 0 || currentStep > 3)) {
                        // navigateTo(1)
                    }

                } catch (error) {
                }
                setLoading(false)
            }
        };

        fetchApplication();
    }, []);


    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    const handleSubmitCustom = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
    };

    return (
        <form onSubmit={handleSubmitCustom}>
            <Grid container>
                {' '}
                {currentStep === 0 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <>

                                <Grid container className={`${classes.acceptedDeclinedFormContainer} ${classes.formContainer}`}>
                                    <Grid item xs={12} md={5}>
                                        <img src={phoneAndHouse} alt="PhoneAndHouse" style={{
                                            width: '30rem',
                                            maxWidth: '100%'
                                        }} />
                                    </Grid>
                                    <Grid item xs={12} md={7}>
                                        <Typography variant="body1" className={classes.acceptedDeclinedText}>
                                            {t('afterShowing.declined')}
                                        </Typography>
                                        <Typography variant="body1" component="ul" className={classes.listItems}>
                                            <li>{t('afterShowing.declinedDisclaimer1')}</li>
                                            {/* <li>{t('afterShowing.declinedDisclaimer2')}</li>
                                                <li>{t('afterShowing.declinedDisclaimer3')}</li>
                                                <li>{t('afterShowing.declinedDisclaimer4')}</li> */}
                                        </Typography>
                                    </Grid>

                                    <Button
                                        fullWidth
                                        color='primary'
                                        className={`${classes.responsiveButton}`}
                                        style={{
                                            boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)',
                                            marginTop: '3rem', borderRadius: '10px'
                                        }}
                                        onClick={resetNotInterested}
                                    >
                                        <Typography variant='h6' style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                                            {t('afterShowing.changedMind')}
                                        </Typography>
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </>
                )}
                {currentStep === 1 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid xs={12} md={12} className={`${classes.marginAuto}`}>
                                <AcceptOrDecline
                                    readyForMoveDate={readyForMoveDate}
                                    t={t}
                                    applicationCode={applicationCode}
                                    classes={classes}
                                    beforeLogin={beforeLogin}
                                    navigateTo={navigateTo}
                                //doNextStep={updateApartmentInformation}
                                />
                            </Grid>
                        )}
                    </>
                )}
                {currentStep === 2 && (
                    <>
                        {submitting === true || isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12}>
                                    <Grid container xs={12} md={12} className={classes.marginAuto}>
                                        {' '}
                                        <Grid item xs={12} className={classes.responsiveWidth}>
                                            <Grid item xs={12}>
                                                <div className={classes.headerStyle}>
                                                    {t('instantRent.onlineBankingCredentialsTitle')}
                                                </div>
                                                <Typography
                                                    variant='body1'
                                                    className={classes.authDesc}
                                                >
                                                    <pre className='MuiTypography-root MuiTypography-body1'>
                                                        {t('instantRent.onlineBankingCredentialsDesc')}{' '}
                                                        <a
                                                            style={{ color: '#4f9b44' }}
                                                            href='https://www.fiksuvuokraus.fi/tietosuojaseloste'
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            {t('instantRent.hereTitle')}
                                                        </a>.
                                                    </pre>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    style={{ marginRight: '0px', marginLeft: '0px' }}
                                                    control={
                                                        <Field
                                                            inputStyles={classes.checkboxField}
                                                            name='acceptedTc'
                                                            component={ReduxCheckbox}
                                                            disabled={false}
                                                        />
                                                    }
                                                    label={
                                                        <div>
                                                            {t(
                                                                'instantRent.onlineBankingCredentialsCheckboxLabel'
                                                            )}
                                                        </div>
                                                    }
                                                />
                                            </Grid>
                                            {isEmpty && (
                                                <Typography style={{ color: 'red' }} variant='body1'>
                                                    {t('apartment.actions.stepFail')}
                                                </Typography>
                                            )}
                                            <Grid item xs={12}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <button
                                                    style={{
                                                        background: 'transparent',
                                                        border: 'none',
                                                        width: '100%',
                                                        marginLeft: '-4px',
                                                        marginRight: '-4px',
                                                    }}
                                                    type='submit'
                                                    disabled={isDisabled}
                                                >
                                                    <StartAuthTrigger
                                                        suggestContainerStyle={classes.authPrompt}
                                                        hideSuggestIcon
                                                        renderText={() => (
                                                            <Grid
                                                                container
                                                                justify='center'
                                                                alignItems='center'
                                                                direction={isMobile ? 'column' : 'row'}
                                                            >
                                                                <Grid
                                                                    item
                                                                    className={isMobile ? `${classes.mb6}` : ''}
                                                                >
                                                                    <img src={OutlineLockPersonIcon} />
                                                                </Grid>
                                                                <Grid item>
                                                                    <Typography
                                                                        variant='h6'
                                                                        className={`${classes.centeredText} ${classes.boldText}`}
                                                                    >
                                                                        {t('instantRent.startAuthentication')}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                        isModal
                                                        customSuggestTextStyles={`${classes.customSuggestTextStyles} ${classes.centeredText}`}
                                                        doNextStep={startCreditScoreAuth}
                                                        submit
                                                        setIsEmpty={setIsEmpty}
                                                        beforeLogin={beforeLogin}
                                                        toValidate={{
                                                            acceptedTc
                                                        }}
                                                    />
                                                </button>
                                            </Grid>
                                        </Grid>
                                        {/* <CircularProgress color='inherit' /> */}
                                        <Grid
                                            className={classes.responsiveWidth}
                                            container
                                            direction={isMobile ? 'column' : 'column-reverse'}
                                        >
                                            <Grid
                                                container
                                                direction={isMobile ? 'column-reverse' : 'column'}
                                                className={classes.buttons}
                                                alignItems='center'
                                            >
                                                <Grid item className={classes.fullWidth}>
                                                    <BackButton
                                                        currentStep={currentStep}
                                                        classes={classes}
                                                        doStepBack={doStepBack}
                                                        customStyle={`${classes.shadowSecondaryButton} ${classes.mBottom}`}
                                                    />
                                                </Grid>
                                                {/* <Grid item className={classes.fullWidth}>
                                                    <Dialog
                                                        dialogId='UpdateStatusToCancelled'
                                                        disabled={false}
                                                        buttonLabel={t(
                                                            'instantRent.buttonLabels.stopRenting'
                                                        )}
                                                        buttonFullWidth
                                                        confirmDialogSubmitAction={() =>
                                                            console.log('confirm2')
                                                        }
                                                        buttonClassName={`${classes.cancelTextButton}`}
                                                        hideCloseIcon
                                                        className={classes.dialogContanier}
                                                        borderRadius={'35px'}
                                                        confirmLabel={t(
                                                            'instantRent.buttonLabels.continueRenting'
                                                        )}
                                                        customButtonContainerDirection={'column-reverse'}
                                                        customButtonContainerClassName={
                                                            classes.centeredText
                                                        }
                                                        buttonContainerStyles={classes.mb14}
                                                        customButtonConfirmClassName={
                                                            classes.modalPrimaryButton
                                                        }
                                                        customButtonCloseClassName={
                                                            classes.modalSecondaryButton
                                                        }
                                                        closeLabel={t(
                                                            'instantRent.buttonLabels.stopRenting'
                                                        )}
                                                        beforeCloseDialogAction={cancelApplication}
                                                        Content={
                                                            <TerminationOfTenancyModal
                                                                classes={classes}
                                                                t={t}
                                                            />
                                                        }
                                                    />
                                                </Grid> */}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* suspended rental alert */}
                                {authenticationError ===
                                    true /* authentication failure alert */ && (
                                        <div className={dialogClasses.root}>
                                            <ConfirmationDialogRaw
                                                maxWidth='sm'
                                                classes={{
                                                    paper: dialogClasses.paper
                                                }}
                                                keepMounted
                                                open={open}
                                            >
                                                <Box className={classes.authPop}>
                                                    <Box
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginBottom: 20
                                                        }}
                                                    >
                                                        <CancelIcon size='5em' color='#D43838' />
                                                    </Box>
                                                    <Typography
                                                        style={{ maxWidth: 300, margin: 'auto' }}
                                                        align='center'
                                                        variant='h5'
                                                    >
                                                        {t('instantRent.authenticationFailedTitle')}
                                                    </Typography>
                                                    <Box
                                                        style={{
                                                            paddingTop: 20,
                                                            paddingBottom: 20
                                                        }}
                                                    >
                                                        <Typography align='center' variant='h6'>
                                                            {duplicateAuthentication ?
                                                                t('instantRent.authenticationFailedDuplicateDescription') :
                                                                t('instantRent.authenticationFailedDescription')}
                                                        </Typography>
                                                    </Box>
                                                    <Button
                                                        fullWidth
                                                        variant='contained'
                                                        color='primary'
                                                        className={`${classes.responsiveButton}`}
                                                        onClick={handleRestartApplication}
                                                    >
                                                        <Typography variant='h6'>
                                                            {t('instantRent.buttonLabels.tryAgain')}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            </ConfirmationDialogRaw>
                                        </div>
                                    )}
                                {applicantCreditStatus === true && (
                                    <div className={dialogClasses.root}>
                                        <ConfirmationDialogRaw
                                            maxWidth='sm'
                                            classes={{
                                                paper: dialogClasses.paper
                                            }}
                                            keepMounted
                                            open={open}
                                        >
                                            <Box className={classes.authPop}>
                                                <Box
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginBottom: 20
                                                    }}
                                                >
                                                    <CancelIcon size='5em' color='#D43838' />
                                                </Box>
                                                <Typography
                                                    style={{ maxWidth: 300, margin: 'auto' }}
                                                    align='center'
                                                    variant='h5'
                                                >
                                                    {t('instantRent.rentalSuspendedTitle')}
                                                </Typography>
                                                <Box
                                                    style={{
                                                        paddingTop: 20,
                                                        paddingBottom: 20
                                                    }}
                                                >
                                                    <Typography align='center' variant='h6'>
                                                        {t('instantRent.rentalSuspendedDiscription')}
                                                    </Typography>
                                                </Box>
                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    color='primary'
                                                    className={`${classes.responsiveButton}`}
                                                    onClick={handleRestartApplication}
                                                >
                                                    <Typography variant='h6'>
                                                        {t('instantRent.buttonLabels.tryAgain')}
                                                    </Typography>
                                                </Button>
                                            </Box>
                                        </ConfirmationDialogRaw>
                                    </div>
                                )}
                            </Grid>
                        )}
                    </>

                )}

                {currentStep === 3 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12}>
                                    <Grid container xs={12} md={12} className={classes.marginAuto}>
                                        {' '}
                                        <Grid item xs={12} className={classes.responsiveWidth}>
                                            <Grid item xs={12} style={{ textAlign: 'center' }}> {/* Center content */}
                                                <div className={classes.headerStyle}>
                                                    {t('instantRent.applicantInfoFormTitle')}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} style={{ textAlign: 'center', marginTop: '20px' }}> {/* Center content and add space */}
                                                <Typography
                                                    className={`${classes.heading}`}
                                                >
                                                    {t('afterShowing.applicantInfoFormDisclaimer')}
                                                </Typography>
                                            </Grid>
                                            {isEmpty && (
                                                <Typography
                                                    align='center'
                                                    style={{ color: 'red', paddingTop: 20 }}
                                                    variant='body1'
                                                >
                                                    {t('apartment.actions.stepFail')}
                                                </Typography>
                                            )}
                                            <Grid
                                                container
                                                spacing={4}
                                                className={classes.containerItem}
                                            >
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.email')}:
                                                    </Typography>
                                                    <ReduxFormField
                                                        autoComplete='username'
                                                        name='contactEmail'
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[required, noSpaceValue, validateEmail]}
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.phone')}:
                                                    </Typography>
                                                    <ReduxFormField
                                                        autoComplete='tel'
                                                        name='phoneNumber'
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[
                                                            required,
                                                            noSpacesPhoneNum,
                                                            validatePhoneNumber
                                                        ]}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={4}
                                                className={classes.containerItem}
                                            >
                                                <Grid item xs={12} sm={12}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.address')}:
                                                    </Typography>

                                                    <ReduxFormField
                                                        name='autocompleteLocation'
                                                        // normalize={charsSpace}
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[requiredLocation, isInvalidCharacters]}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={4}
                                                className={classes.containerItem}
                                            >
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.postalCode')}:
                                                    </Typography>
                                                    <ReduxFormField
                                                        name='postalCode'
                                                        normalize={onlyNums}
                                                        min={0}
                                                        validate={[
                                                            required,
                                                            isPostalCode,
                                                            isInvalidCharacters
                                                        ]}
                                                        required
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.place')}:
                                                    </Typography>

                                                    <ReduxFormField
                                                        name='postalArea'
                                                        normalize={charsSpace}
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[requiredLocation, isInvalidCharacters]}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                direction={isMobile ? 'column' : 'column-reverse'}
                                            >
                                                <Grid
                                                    container
                                                    direction={isMobile ? 'column-reverse' : 'column'}
                                                    className={classes.buttons}
                                                    alignItems='center'
                                                >
                                                    <Grid item className={classes.fullWidth}>
                                                        {/* <NextStepButton
                          customStyles={classes.primaryBtn}
                          classes={classes}
                          beforeLogin={beforeLogin}
                          setIsEmpty={setIsEmpty}
                        /> */}
                                                        {/* <NextStepButton
                            classes={classes}
                            setIsEmpty={setIsEmpty}
                            disabled={isDisabled}
                            beforeLogin={beforeLogin}
                            toValidate={{
                              contactEmail,
                              phoneNumber,
                              autocompleteLocation,
                              postalCode,
                              postalArea
                            }}
                          /> */}
                                                        <Button
                                                            // disabled={isChecked}
                                                            fullWidth
                                                            variant='contained'
                                                            color='primary'
                                                            className={`${classes.responsiveButton}`}
                                                            onClick={handleFormEvent}
                                                            style={{
                                                                borderRadius: '10px',
                                                                marginLeft: '-4px',
                                                                marginRight: '-4px'
                                                            }}
                                                        >
                                                            <Grid
                                                                container
                                                                justify='center'
                                                                alignItems='center'
                                                            >
                                                                <Grid item>{t('general.next')}</Grid>
                                                                <Grid item className={classes.rightFloatingIcon}>
                                                                    <ChevronRightIcon color='#D8DCDF' />
                                                                </Grid>
                                                            </Grid>
                                                        </Button>
                                                    </Grid>
                                                    {/* <Grid item className={classes.fullWidth}>
                                                        <Dialog
                                                            dialogId='UpdateStatusToCancelled'
                                                            disabled={false}
                                                            buttonLabel={t(
                                                                'instantRent.buttonLabels.stopRenting'
                                                            )}
                                                            buttonFullWidth
                                                            confirmDialogSubmitAction={() =>
                                                                console.log('confirm3')
                                                            }
                                                            buttonClassName={`${classes.cancelTextButton}`}
                                                            hideCloseIcon
                                                            className={classes.dialogContanier}
                                                            borderRadius={'35px'}
                                                            confirmLabel={t(
                                                                'instantRent.buttonLabels.continueRenting'
                                                            )}
                                                            customButtonContainerDirection={'column-reverse'}
                                                            customButtonContainerClassName={
                                                                classes.centeredText
                                                            }
                                                            buttonContainerStyles={classes.mb14}
                                                            customButtonConfirmClassName={
                                                                classes.modalPrimaryButton
                                                            }
                                                            customButtonCloseClassName={
                                                                classes.modalSecondaryButton
                                                            }
                                                            closeLabel={t(
                                                                'instantRent.buttonLabels.stopRenting'
                                                            )}
                                                            beforeCloseDialogAction={cancelApplication}
                                                            Content={
                                                                <TerminationOfTenancyModal
                                                                    classes={classes}
                                                                    t={t}
                                                                />
                                                            }
                                                        />
                                                    </Grid> */}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {newRentDialog !== null ? (
                                        <>
                                            <div className={dialogClasses.root}>
                                                <ConfirmationDialogRaw
                                                    maxWidth="sm"
                                                    classes={{
                                                        paper: dialogClasses.paper
                                                    }}
                                                    keepMounted
                                                    open={open}
                                                >
                                                    <Box className={classes.addNewTenantStyles}>
                                                        <Typography
                                                            style={{ maxWidth: 300, margin: 'auto' }}
                                                            align="center"
                                                            variant="h5"
                                                        >
                                                            {t('instantRent.doYouWantToAdd')}
                                                        </Typography>
                                                        <Box
                                                            className={classes.addNewTenantDetailsStyle}
                                                            mt={4}
                                                            mb={4}
                                                        >
                                                            <img
                                                                src={suggestIcon}
                                                                className={classes.suggestIcon}
                                                                alt={'Suggest Icon'}
                                                            />
                                                            <Typography
                                                                style={{ paddingLeft: 20 }}
                                                                align="left"
                                                                variant="body1"
                                                            >
                                                                {t('instantRent.addLease')}
                                                            </Typography>
                                                        </Box>
                                                        {!showEmailForm && (
                                                            <Button
                                                                fullWidth
                                                                color="primary"
                                                                variant={showEmailForm ? 'outlined' : 'contained'}
                                                                className={`${classes.responsiveButton}`}
                                                                onClick={() => goFromStep3To4()}
                                                            >
                                                                <Typography variant="h6">
                                                                    {t('instantRent.proceedToNextStep')}
                                                                </Typography>
                                                            </Button>
                                                        )}
                                                        {!showEmailForm && (
                                                            <Box
                                                                style={{
                                                                    marginBottom: '10px'
                                                                }}>
                                                                <Button
                                                                    fullWidth
                                                                    color="primary"
                                                                    className={`${classes.responsiveButton}`}
                                                                    style={{
                                                                        boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)',
                                                                        marginBottom: '10px'
                                                                    }}
                                                                    onClick={addNewTenant}
                                                                >
                                                                    <Typography variant="h6">
                                                                        {t('instantRent.addNewApplicant')}
                                                                    </Typography>
                                                                </Button>
                                                                {emailSent && (
                                                                    <Typography variant="body2"
                                                                        style={{ marginTop: '8px', color: '#4f9b44', textAlign: 'center' }}
                                                                    >
                                                                        {t('afterShowing.emailSent')}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        )}
                                                        {showEmailForm && (
                                                            <Box style={{ marginBottom: '10px' }}>
                                                                <TextField
                                                                    fullWidth
                                                                    label={t('afterShowing.emailAddress')}
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    variant="outlined"
                                                                    type="email"
                                                                    style={{ marginTop: '10px' }}
                                                                />
                                                                <Button
                                                                    fullWidth
                                                                    color="primary"
                                                                    variant="contained"
                                                                    className={`${classes.responsiveButton}`}
                                                                    onClick={handleSendEmail}
                                                                    style={{ marginTop: '10px' }}
                                                                >
                                                                    <Typography variant="h6">
                                                                        {t('afterShowing.sendEmail')}
                                                                    </Typography>
                                                                </Button>
                                                                {emailValidationError && (
                                                                    <Typography variant="body2" style={{ marginTop: '8px', color: 'red', textAlign: 'center' }}>
                                                                        {t('afterShowing.invalidEmail')}
                                                                    </Typography>
                                                                )}
                                                                {emailError && (
                                                                    <Typography variant="body2" style={{ marginTop: '8px', color: 'red', textAlign: 'center' }}>
                                                                        {t('afterShowing.emailError')}
                                                                    </Typography>
                                                                )}
                                                                <Button
                                                                    fullWidth
                                                                    color="primary"
                                                                    variant={showEmailForm ? 'outlined' : 'contained'}
                                                                    className={`${classes.responsiveButton}`}
                                                                    onClick={() => goFromStep3To4()}
                                                                >
                                                                    <Typography variant="h6">
                                                                        {t('instantRent.proceedToNextStep')}
                                                                    </Typography>
                                                                </Button>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </ConfirmationDialogRaw>
                                            </div>
                                        </>
                                    ) : null}
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}
                {currentStep === 4 && (
                    <Grid container className={`${classes.acceptedDeclinedFormContainer} ${classes.formContainer}`}>
                        <Grid item xs={12} md={5}>
                            <img src={phoneAndHouse} alt="PhoneAndHouse" style={{
                                width: '30rem',
                                maxWidth: '100%'
                            }} />
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body1" className={classes.acceptedDeclinedText}>
                                {t('afterShowing.accepted')}
                            </Typography>
                            <Typography variant="body1" component="ul" className={classes.listItems}>
                                <li>{t('afterShowing.acceptedDisclaimer1')}</li>
                                {/* <li>{t('afterShowing.acceptedDisclaimer2')}</li>
                                <li>{t('afterShowing.acceptedDisclaimer3')}</li>
                                <li>{t('afterShowing.acceptedDisclaimer4')}</li> */}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </form>
    )
}

const selector = formValueSelector('InstantRentForm')

const mapStateToProps = (state: StateInterface) => ({
    readyForMoveDate: selector(state, 'readyForMoveDate'),
    movingWithAmount: selector(state, 'movingWithAmount'),
    acceptedTc: selector(state, 'acceptedTc'),
    contactEmail: selector(state, 'contactEmail'),
    phoneNumber: selector(state, 'phoneNumber'),
    autocompleteLocation: selector(state, 'autocompleteLocation'),
    postalCode: selector(state, 'postalCode'),
    postalArea: selector(state, 'postalArea')
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeFormValue: (field: string, value: string) =>
        dispatch(change('InstantRentForm', field, value)),
    doNextStep: (beforeLogin: boolean) =>
        dispatch(stepAfterShowingForward({ beforeLogin }))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'InstantRentForm'
    })(
        withStyles(styles)(withTranslation()(InstantRentForm as any)) as any
    ) as any
) as any
